export const FILE_COVER_CATEGORY = '__file_cover__';
